// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  /*production: false,
  restBaseUrl: 'http://192.168.2.55:8080/atb/rest/v2/permessituristici/',
  restDownloadPdf: 'http://192.168.2.55:8080/atb/',
  restBaseRedirect: 'http://192.168.2.55:8080/atb/#mdl=',
  logoutPath: 'http://192.168.2.55:8080/atb/rest/v2/logout',
  uploadUrl: 'http://192.168.2.55:8080/atb/rest/v2/UploadAllegatiPermessiTuristici?id=',
*/

  production: true,
  restBaseUrl: 'https://testservice.atb.bergamo.it/atb/rest/v2/',
  restBaseRedirect: 'https://testservice.atb.bergamo.it/atb/#mdl=',
  baseUrl: 'https://testservice.atb.bergamo.it/atb/',
  paymentUrl: 'https://int-ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
  version: '1.8.0',
  rows: 5
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts